import { all, call, SagaReturnType, takeLatest } from "redux-saga/effects";

import { loadCitiesAction } from "store/dictionaries/dictionaries.actions";
import { loadCities } from "api/dictionaries";

function* loadCitiesFlow(action: typeof loadCitiesAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof loadCities> = yield call(loadCities)
    yield call(loadCitiesAction.sagas.resolve, action, data)
  } catch (e: any) {
    yield call(loadCitiesAction.sagas.reject, action, e?.message)
  }
}

export default function* administrationSaga() {
  yield all([
    takeLatest(loadCitiesAction.trigger, loadCitiesFlow),
  ]);
}